import { setDefaultLevel } from 'loglevel';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { NODE_ENV } from './constants';
import { Main } from './main';

import './index.css';

if (NODE_ENV === 'development') {
  setDefaultLevel('debug');
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(<Main />);
